export const chatStages = [
  "invitation", 
  "connection", 
  "exchange",
  "agreement",
  "reflection",
]